import Select, { components } from "react-select";

import { Check, ChevronBottom, X } from "../../Icons/general-interface-1";
import {
  control,
  clearIndicator,
  dropdownIndicator,
  indicatorSeparator,
  option,
  menu,
  menuList,
  placeholder,
  valueContainer,
} from "../commonStyles";
import commonStyles from "../index.module.scss";
import styles from "./index.module.scss";

type PropsType = {
  onChange: (status: { value: cepType; label: string }) => void;
  defaultValue?: { value: cepType; label: cepType };
  value?: { value: cepType; label: string };
};

const ClearIndicator = ({ ...props }) => (
  <components.ClearIndicator {...props}>
    <X />
  </components.ClearIndicator>
);

const DropdownIndicator = ({ ...props }) => (
  <components.DropdownIndicator {...props}>
    <ChevronBottom />
  </components.DropdownIndicator>
);

const Option = (props) => (
  <components.Option {...props}>
    <div className={styles.optionLabel}>{props.data.label}</div>
    {props.isSelected && <Check className={styles.iconCheck} />}
  </components.Option>
);

const SingleValue = ({ ...props }) => (
  <components.SingleValue {...props}>
    {props.data.value === "yes" ? "CEP-enabled" : "Not CEP-enabled"}
  </components.SingleValue>
);

const customStyles = {
  control,
  dropdownIndicator,
  clearIndicator,
  indicatorSeparator,
  option,
  menu,
  menuList,
  placeholder,
  valueContainer,
  singleValue: (provided) => ({
    ...provided,
    color: commonStyles.grey_500,
    fontFamily: commonStyles.font,
    fontSize: "16px",
  }),
};

export const cepList = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
] as const;

export type cepType = typeof cepList[number]["value"];

const CepFilterDropdown = ({ onChange, value, defaultValue }: PropsType) => {
  const onDropdownSelect = (selection) => {
    onChange(selection);
  };

  return (
    <Select
      styles={customStyles}
      value={!value ? null : value}
      defaultValue={defaultValue}
      classNamePrefix="statusFilterDropdown"
      placeholder="Filter by CEP"
      onChange={onDropdownSelect}
      options={cepList}
      maxMenuHeight="197px"
      isSearchable={false}
      isClearable
      components={{
        DropdownIndicator,
        ClearIndicator,
        Option,
        SingleValue,
      }}
    />
  );
};

export default CepFilterDropdown;
